// SidePanel — the left control panel aside (US-874 shell · responsive).
//
// Hosts the active tabbed view (PanelHost). Used in two placements: as a grid
// cell on desktop (gridArea "panel" → 420px column) and inside the mobile nav
// Drawer (flex child filling the slide-over). `flex: 1` is ignored in the grid
// and fills the drawer on mobile.
import Box from "@mui/material/Box";
import PanelHost from "./PanelHost";

const SidePanel = () => (
  <Box
    component="aside"
    aria-label="Control panel"
    data-region="panel"
    sx={{
      gridArea: "panel",
      flex: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      bgcolor: "background.paper",
      borderRight: 1,
      borderColor: "divider",
      overflowX: "hidden",
      overflowY: "auto",
      position: "relative",
      zIndex: 10,
    }}
  >
    <PanelHost />
  </Box>
);

export default SidePanel;
